import React, { useMemo } from 'react';
import { IQuestionListItem, QuestionAnswerMode } from '@/types';
import { Image } from 'antd';
import Luckysheet from './luckysheet';
import { downloadFile, transformDurationTime } from '@/utils';
import { QuestionTeacherDownloadIcon } from '@/svgs';
import { useAppStore } from '@/store';
import { CpaCorrectContent, GwyCorrectContent } from './correct-ai-content';

interface IProps {
    questionItem: IQuestionListItem;
    removeMyAnswer?: boolean; // 移除我的答案
    removeQuestionUseTime?: boolean; // 移除答题用时
}

const ShortAnswerAnalysis = (props: IProps) => {
    const { commonStore } = useAppStore();
    const { isOpenPersonalCorrect } = commonStore.common;
    const { questionItem, removeMyAnswer, removeQuestionUseTime } = props;
    const { questionId, userAnswer, excelAnswerContent, answerMode = 0, aiCorrect } = questionItem;

    const isGwyCorrect = aiCorrect?.aiBotType === 2; // 是否开启 公务员批改
    const isCpaCorrect = aiCorrect?.cpaBotType === 3; // 是否开启 cpa批改
    const isOpenQuestionCorrect = !isOpenPersonalCorrect && (isCpaCorrect || isGwyCorrect);

    // lucky表格
    const excelAnswer = userAnswer?.excelAnswer ? userAnswer?.excelAnswer : excelAnswerContent;

    // 用户答案
    const userValue = userAnswer?.userAnswer || '';

    const excelData = useMemo(() => {
        let data = null;
        try {
            data = JSON.parse(excelAnswer);
        } catch (error) {}
        return data;
    }, [excelAnswer]);

    const renderAnswer = () => {
        return (
            !removeMyAnswer && (
                <div className="sub-tiku__question-right-statics">
                    <div className="sub-tiku__statics-title">我的答案：</div>
                    {[QuestionAnswerMode.text].includes(answerMode) && (
                        <div
                            className="sub-tiku__short-defalult-answer"
                            style={{ marginTop: 20 }}
                            dangerouslySetInnerHTML={{
                                __html: String(userValue || '-'),
                            }}
                        />
                    )}

                    {[QuestionAnswerMode.word].includes(answerMode) && (
                        <div
                            className="sub-tiku__short-defalult-answer"
                            style={{ marginTop: 20 }}
                            dangerouslySetInnerHTML={{
                                __html: String(userValue || '-'),
                            }}
                        />
                    )}

                    {[QuestionAnswerMode.excelLucky, QuestionAnswerMode.excel].includes(answerMode) && (
                        <Luckysheet allowEdit={false} excelData={excelData} key={questionId} />
                    )}

                    {[QuestionAnswerMode.textAndExcel].includes(answerMode) && (
                        <>
                            <div
                                style={{ marginBottom: 20 }}
                                dangerouslySetInnerHTML={{
                                    __html: String(userValue),
                                }}
                            />
                            <Luckysheet allowEdit={false} excelData={excelData} key={questionId} />
                        </>
                    )}

                    {[QuestionAnswerMode.excelAndText].includes(answerMode) && (
                        <>
                            <Luckysheet allowEdit={false} excelData={excelData} key={questionId} style={{ marginBottom: 20 }} />

                            <div
                                dangerouslySetInnerHTML={{
                                    __html: String(userValue),
                                }}
                            />
                        </>
                    )}

                    {Boolean(questionItem.userAnswer?.userAnswerImagesList?.length) && (
                        <div className="sub-tiku__shortAnswerImgBox" style={{ marginTop: 20 }}>
                            <Image.PreviewGroup>
                                {questionItem.userAnswer!.userAnswerImagesList!.map(image => (
                                    <div className="sub-tiku__shortAnswerImgItem" key={image}>
                                        <Image key={image} src={image} />
                                    </div>
                                ))}
                            </Image.PreviewGroup>
                        </div>
                    )}
                </div>
            )
        );
    };

    return (
        <>
            {isOpenQuestionCorrect && (
                <>
                    {isGwyCorrect && <GwyCorrectContent questionItem={questionItem} />}
                    {isCpaCorrect && <CpaCorrectContent questionItem={questionItem}>{renderAnswer()}</CpaCorrectContent>}
                </>
            )}

            {!isOpenQuestionCorrect && renderAnswer()}

            {isOpenPersonalCorrect && questionItem.userAnswer?.correctStatus === 2 && (
                <div className="sub-tiku__question-right-statics">
                    <div className="sub-tiku__statics-title">
                        批阅得分：
                        <span className="sub-tiku__default">{questionItem.userAnswer?.userScore}分</span>
                    </div>

                    <div style={{ marginTop: 20 }} className="sub-tiku__statics-title">
                        得分评语：
                    </div>
                    <div
                        className="sub-tiku__statics-content"
                        dangerouslySetInnerHTML={{
                            __html: questionItem.userAnswer?.questionReviewObject + '' || '-',
                        }}
                    />

                    {questionItem.userAnswer?.correctFileUrl && (
                        <div style={{ marginTop: 20, display: 'flex' }} className="sub-tiku__statics-title sub-tiku__statics-teacher-file">
                            评语附件：
                            <QuestionTeacherDownloadIcon
                                className="sub-tiku__statics-teacher-file"
                                onClick={() => downloadFile(questionItem.userAnswer!.correctFileUrl!)}
                            />
                        </div>
                    )}
                </div>
            )}

            <div className="sub-tiku__question-right-statics">
                <div className="sub-tiku__statics-title">正确答案：</div>
                <div
                    className="sub-tiku__statics-content sub-tiku__right"
                    dangerouslySetInnerHTML={{
                        __html: questionItem.questionAnswer?.answer + '' || '-',
                    }}
                />

                {!removeQuestionUseTime && (
                    <div style={{ marginTop: 20 }} className="sub-tiku__statics-content">
                        答题用时：
                        <span className="sub-tiku__default">
                            {questionItem.userAnswer?.costTime ? transformDurationTime(questionItem.userAnswer.costTime) : '-'}
                        </span>
                    </div>
                )}
            </div>
        </>
    );
};

export default ShortAnswerAnalysis;
